import { addDays, format, getDay } from "date-fns";

export function setCalendarDays() {
  const tomorrow = addDays(new Date(), 1);
  const tomorrowDayOfWeek = getDay(tomorrow);
  const tomorrowIndex = tomorrowDayOfWeek === 0 ? 7 : tomorrowDayOfWeek;

  for (let i = 1; i <= 7; i++) {
    let dayDate;

    if (i >= tomorrowIndex) {
      const daysFromToday = i - tomorrowIndex;
      dayDate = addDays(tomorrow, daysFromToday);
    } else {
      const daysFromToday = 7 - tomorrowIndex + i;
      dayDate = addDays(tomorrow, daysFromToday);
    }

    const element = document.querySelector(
      `.template-trials h4 .calendar-date.${format(
        dayDate,
        "EEEE"
      ).toLowerCase()}`
    );
    if (element) {
      element.innerHTML = format(dayDate, "MM/dd");
    }
  }
}
